<template>
    <div class="chat-container">
        <PreLoader v-if="isLoading"/>
        <div class="flex row justify-center" v-if="schoolId">
            <div class="scl-ad_title" v-html="$t('messages')" style="width: max-content"/>
            <v-select class="v-select-item" :no-data-text="$t('no_data')" outlined dense item-text="title"
                      item-value="role" :items="roles" v-model="selectedTab" @change="showUsers"/>
        </div>
        <div class="messaging" v-if="schoolId">
            <div class="inbox_msg">
                <div class="inbox_people">
                    <div class="recent_heading"><h4 v-html="$t('list')"/></div>
                    <div style="padding: 8px 8px 0 8px">
                        <v-text-field outlined dense append-icon="mdi-close" :placeholder="$t('search')"
                                      v-model="searchQuery" @keyup.enter="searchUser" @click:append="clearSearch"/>
                    </div>
                    <v-divider/>
                    <div class="inbox_chat">
                        <div class="chat_list" v-for="user in users" :key="user.id" @click="onSelectUser(user)"
                             :class="{'active_chat': recipientUserId === user.userId}">
                            <div class="chat_people">
                                <div class="chat_img"><img src="@/assets/images/icons/profile-icon.svg"></div>
                                <div class="chat_ib">
                                    <h5>{{ user.fullName }} <span class="chat_date">...</span></h5>
                                    <p>...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mesgs">
                    <div class="msg_history" ref="msgHistory">
                        <div v-if="members.length" style="padding: 12px 0">
                            <div @click="show = !show" class="member-txt">Участники</div>
                            <v-expand-transition>
                                <div v-show="show">
                                    <v-divider/>
                                    <div class="members-block">
                                        <span v-for="(member, m) in members" :key="m"
                                              class="member-txt-us" v-html="member.fullName"/>
                                    </div>
                                </div>
                            </v-expand-transition>
                            <v-divider/>
                        </div>
                        <template v-for="(message) in messages">
                            <div class="outgoing_msg" v-if="message.authorId === userProfile.user.id">
                                <div class="sent_msg">
                                    <p v-html="message.contents"/>
                                    <span class="time_date" v-html="message.sentDateTime"/>
                                </div>
                            </div>
                            <div class="incoming_msg" v-else>
                                <div class="received_msg">
                                    <div class="received_withd_msg">
                                        <p><span class="received-name" v-if="members.length">
                                            {{message.authorName}}<br></span>{{ message.contents }}</p>
                                        <span class="time_date" v-html="message.sentDateTime"/>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="type_msg">
                        <div class="input_msg_write" v-if="recipientUserId">
                            <input type="text" v-model="inputValue" @keyup.enter="sendMessage" class="write_msg"
                                   :placeholder="$t('writeMessage')"/>
                            <button class="msg_send_btn" type="button" @click.prevent="sendMessage">
                                <img src="@/assets/images/icons/send-icon.svg">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="chat-mob">
                <v-card class="chat-mob-card">
                    <v-card-text class="chat-mob-card-text">
                        <v-icon @click.stop="drawer = !drawer">mdi-account-multiple-outline</v-icon>
                        <span>{{currUserName}}</span>
                    </v-card-text>
                    <v-divider/>
                    <v-card-text style="width: 100%;">
                        <v-navigation-drawer v-model="drawer" absolute left temporary style="padding: 8px">
                            <div class="chat-mob-card-search-block">
                                <v-text-field append-icon="mdi-close" :placeholder="$t('search')" @keyup.enter="searchUser"
                                              v-model="searchQuery" @click:append="clearSearch" outlined dense/>
                                <v-divider/>

                            </div>
                            <div style="margin-top: 66px">
                                <div class="chat_list" v-for="user in users" :key="user.id" @click="onSelectUser(user)"
                                     :class="{'active_chat': recipientUserId === user.userId}">
                                    <div class="chat_people">
                                        <div class="chat_img"><img src="@/assets/images/icons/profile-icon.svg"></div>
                                        <div class="chat_ib">
                                            <h5>{{ user.fullName }} <span class="chat_date">...</span></h5>
                                            <p>...</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-navigation-drawer>
                        <div style="width: 100%;">
                            <div class="msg_history" ref="msgHistory" style="overflow: scroll; margin: 0; height: 250px">
                                <template v-for="message in messages">
                                    <div class="outgoing_msg" v-if="message.authorId === userProfile.user.id">
                                        <div class="sent_msg">
                                            <p>{{ message.contents }}</p>
                                            <span class="time_date">{{ message.sentDateTime }}</span>
                                        </div>
                                    </div>
                                    <div class="incoming_msg" v-else>
                                        <div class="received_msg">
                                            <div class="received_withd_msg">
                                                <p><span class="received-name" v-if="members.length">
                                                    {{message.authorName}}<br></span>{{ message.contents }}</p>
                                                <span class="time_date">{{ message.sentDateTime }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="type_msg">
                                <div class="input_msg_write" v-if="recipientUserId">
                                    <input type="text" v-model="inputValue" @keyup.enter="sendMessage" class="write_msg"
                                           :placeholder="$t('writeMessage')"/>
                                    <button class="msg_send_btn" type="button" @click.prevent="sendMessage">
                                        <img src="@/assets/images/icons/send-icon.svg">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import WebSocketService from '@/_services/websocket.service'
import PreLoader from '@/components/preloader/PreLoader'
import InstructorService from '@/_services/instructor.service'
import { StudentService } from '@/_services/student.service'
import { PersonService } from '@/_services/person.service'
import { StudentParentService } from '@/_services/student-parent.service'
import ChatService from '@/_services/chat.service'
const studentService = new StudentService()
const personService = new PersonService()
const studentParentService = new StudentParentService()

export default {
  components: {
    PreLoader
  },
  data () {
    return {
      show: false,
        roles: [
            { role: 'teacher', title: this.$t('teachers') },
            { role: 'student', title: this.$t('students') },
            { role: 'admin', title: 'Оператор школы' },
            { role: 'group', title: 'Группы' }
        ],
        selectedTab: '',
      userObj: {
        teacher: 'fetchSchoolTeachers',
        student: 'fetchSchoolStudents',
        admin: 'fetchSchoolAdmin',
        director: 'fetchSchoolDirector',
        parent: 'fetchSchoolParents',
        group: 'fetchChatGroup'
      },
      recipientUserId: '',
      inputValue: '',
      messages: [],
      users: [],
        selectedClassId: '',
        classes: [],
      groups: [],
      groupId: '',
      members: [],
      allReserveUsers: [],
      searchQuery: '',
      selectedRole: '',
      currUserName: 'Чат',
        schoolId: undefined,
        classId: undefined,
      isLoading: false,
      drawer: false
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools ? this.userProfile.schools[0] : ''
    }
  },
  mounted () {
    this.onEventHistoryMessages()
    this.onEventNewMessage()
    this.onEventError()
  },
  beforeDestroy () {
    WebSocketService.disconnectSocket()
  },
  methods: {
      showUsers (role) {
          this.selectedTab = role
          this.selectedClassId = ''
          this.selectedRole = role
          this.recipientUserId = ''
          this.users = []
          this.messages = []
          this.allReserveUsers = []
          if (role === 'teacher' || role === 'group' || role === 'admin') {
              this.fetchUsers(this.selectedTab)
          } else {
              this.showUsersByClass(this.classId)
          }
      },

    showUsersByClass (classId) {
        this.fetchUsers(this.selectedTab, classId)
    },
    fetchUsers (role, classId) {
      this.members = []
      this.searchQuery = ''
      this.isLoading = true
      this.selectedRole = role
      this[this.userObj[role]](classId)
    },

    fetchChatGroup () {
      ChatService.getGroup(this.userProfile.user.id, {}).then(result => {
        if (result.length) {
          this.users = result.map((teacher) => {
            teacher.fullName = teacher.title
            teacher.userId = teacher.id ? teacher.id : teacher.userId
            return teacher
          })
        } else {
          this.users = []
        }
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchSchoolAdmin (page) {
      personService.listSchoolAdmins('', '', this.schoolId, this.searchQuery, page ?? 0)
          .then((res) => {
        this.users = res.content.map((admin) => {
          admin.fullName = admin.surname + ' ' + admin.name
          return admin
        })
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchSchoolTeachers () {
      this.users = []
      InstructorService.list(0, this.schoolId, '', '', this.searchQuery).then((res) => {
        if (res._embedded) {
          this.users = res._embedded.instructorResourceList.map((teacher) => {
            teacher.fullName = teacher.lastName + ' ' + teacher.firstName
            return teacher
          }).filter((teacher) => teacher.userId !== this.userProfile.user.id)
        }
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchSchoolStudents (classId) {
      studentService.getByClass(classId).then((res) => {
        this.users = res.map((student) => {
          student.fullName = student.surname + ' ' + student.name
          return student
        })
        this.allReserveUsers = JSON.parse(JSON.stringify(this.users))
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchSchoolParents (classId) {
      studentParentService.getStudentParentList(this.schoolId, classId).then((res) => {
        this.users = res.map((parent) => {
          parent.fullName = parent.parentTitle
          return parent
        })
        this.allReserveUsers = JSON.parse(JSON.stringify(this.users))
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    clearSearch () {
      this.searchQuery = ''
      this.searchUser()
    },

    searchUser () {
      if (this.selectedRole === 'teacher') {
        this.isLoading = true
        this.fetchSchoolTeachers()
      } else if (this.selectedRole === 'student' || this.selectedRole === 'parent') {
        this.users = this.allReserveUsers.filter((user) => user.fullName.toLocaleLowerCase()
            .includes(this.searchQuery.toLocaleLowerCase()))
      }
    },

    onSelectUser (selectedUser) {
      this.members = []
      if (selectedUser.members) {
        this.groupId = selectedUser.id
        this.members = selectedUser.members
      }
      this.currUserName = selectedUser.fullName
      this.drawer = false
      this.messages = []
      this.recipientUserId = selectedUser.userId
      this.openSocketConnection(this.recipientUserId)
    },

    openSocketConnection (recipientUserId) {
      let recUserId = recipientUserId
      let typeChat = 'DIRECT'
      let groupId = ''
      if (this.members.length) {
        recUserId = 0
        typeChat = 'GROUP'
        groupId = this.groupId
      }
      const usersChannel = { userIdOne: this.userProfile.user.id, userIdTwo: recUserId, type: typeChat, groupId: groupId }
      WebSocketService.initChannelConnection(usersChannel)
    },

    sendMessage () {
      this.inputValue = this.inputValue.trim()
      if (this.inputValue.length) {
        const messageObj = {
          authorId: this.userProfile.user.id,
          recipientId: this.recipientUserId,
          contents: this.inputValue
        }
        WebSocketService.sendMsgData(JSON.stringify(messageObj))
        this.inputValue = ''
      }
    },

    getCurrentTime () {
      return moment().format('hh:mm')
    },

    scrollToBottom () {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.msgHistory) {
            this.$refs.msgHistory.scrollTop = this.$refs.msgHistory.scrollHeight
          }
        })
      })
    },

    playSound () {
      const sound = new Audio(require('@/assets/notify-sound.mp3'))
      sound.play()
    },

    onEventHistoryMessages () {
      WebSocketService.eventEmitter.on('oldMessages', (res) => {
        this.messages = res.messages.reverse().map((msg) => {
          msg.sentDateTime = msg.sentDate
          return msg
        })
        this.scrollToBottom()
      })
    },

    onEventNewMessage () {
      WebSocketService.eventEmitter.on('newMessage', (res) => {
        const message = JSON.parse(res.message.body)
        message.sentDateTime = this.getCurrentTime()
        this.messages.push(message)
        this.scrollToBottom()
        this.playSound()
      })
    },

    onEventError () {
      WebSocketService.eventEmitter.on('onError', (err) => {
        this.$toast.error(err)
      })
    }
  }
}
</script>
